import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-note.reducer';

export const ActivityNoteDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityNoteEntity = useAppSelector(state => state.activityNote.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityNoteDetailsHeading">
          <Translate contentKey="activitiesApp.activityNote.detail.title">ActivityNote</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityNoteEntity.id}</dd>
          <dt>
            <span id="itemDetails">
              <Translate contentKey="activitiesApp.activityNote.itemDetails">Item Details</Translate>
            </span>
          </dt>
          <dd>{activityNoteEntity.itemDetails}</dd>
          <dt>
            <Translate contentKey="activitiesApp.activityNote.activity">Activity</Translate>
          </dt>
          <dd>{activityNoteEntity.activity ? activityNoteEntity.activity.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/activity-note" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-note/${activityNoteEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityNoteDetail;
